import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { User } from "../../common/external-sources/Users";
import { Modes } from "../../common/fields/mode";
import { readStoredText, writeStoredText } from "../../common/fields/stored";

export const softwareVersion: FieldSchema = {
  name: "softwareVersion",
  grid: {
    displayed: true,
    order: 27,
  },
  // Declared for both inbound directions: the rule belongs to the attribute, not to
  // whether the record arrived from AppSync or from a DynamoDB read.
  dataTransform: {
    fromGraphql: { getter: ({ softwareVersion }) => readStoredText(softwareVersion) },
    fromDb: { getter: ({ softwareVersion }) => readStoredText(softwareVersion) },
    // Back out as the placeholder: this column is one an index is keyed on, or
    // one the resolvers keep a placeholder in for a consumer's index.
    toDb: { getter: ({ softwareVersion }) => writeStoredText(softwareVersion) },
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Software version",
    disabled: {
      getter: ({ linkedInstance, mode, currentUser }) => {
        return (
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["linkedInstance", "mode", "currentUser"],
    },
  },
};
